import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'cmx-inline-loader',
  templateUrl: './inline-loader.component.html',
  styleUrls: ['./inline-loader.component.scss'],
})
export class InlineLoaderComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
